import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SaveGeoGroupsMutationVariables = Types.Exact<{
  geoGroups: ReadonlyArray<Types.YalperGeoGroupInput> | Types.YalperGeoGroupInput;
}>;


export type SaveGeoGroupsMutationPage = { readonly __typename?: 'RootMutationType', readonly saveGeoGroups: boolean };

export type CreateExceptionMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  sensorName: Types.Scalars['String']['input'];
  platform: Types.YalperPlatform;
  items: ReadonlyArray<Types.YalperExceptionItemInput> | Types.YalperExceptionItemInput;
}>;


export type CreateExceptionMutationPage = { readonly __typename?: 'RootMutationType', readonly createException: boolean };

export type DeleteExceptionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteExceptionMutationPage = { readonly __typename?: 'RootMutationType', readonly deleteException: boolean };

export type SaveAdDoubleSettingsMutationVariables = Types.Exact<{
  settings: Types.YalperAdDoubleSettingsInput;
}>;


export type SaveAdDoubleSettingsMutationPage = { readonly __typename?: 'RootMutationType', readonly saveAdDoubleSettings: boolean };

export type SaveUtmCoherencySettingsMutationVariables = Types.Exact<{
  settings: Types.YalperUtmCoherencySettingsInput;
}>;


export type SaveUtmCoherencySettingsMutationPage = { readonly __typename?: 'RootMutationType', readonly saveUtmCoherencySettings: boolean };

export type SaveUtmFormatMetrikaSettingsMutationVariables = Types.Exact<{
  settings: Types.YalperUtmFormatMetrikaSettingsInput;
}>;


export type SaveUtmFormatMetrikaSettingsMutationPage = { readonly __typename?: 'RootMutationType', readonly saveUtmFormatMetrikaSettings: boolean };

export type SaveUtmFormatAppsflyerWebdavSettingsMutationVariables = Types.Exact<{
  settings: Types.YalperUtmFormatAppsflyerWebdavSettingsInput;
}>;


export type SaveUtmFormatAppsflyerWebdavSettingsMutationPage = { readonly __typename?: 'RootMutationType', readonly saveUtmFormatAppsflyerWebdavSettings: boolean };

export type SaveAsKpiAgeGenderSettingsMutationVariables = Types.Exact<{
  settings: Types.YalperAsKpiAgeGenderSettingsInput;
}>;


export type SaveAsKpiAgeGenderSettingsMutationPage = { readonly __typename?: 'RootMutationType', readonly saveAsKpiAgeGenderSettings: boolean };

export type SaveAsKpiPlaceSettingsMutationVariables = Types.Exact<{
  settings: Types.YalperAsKpiPlaceSettingsInput;
}>;


export type SaveAsKpiPlaceSettingsMutationPage = { readonly __typename?: 'RootMutationType', readonly saveAsKpiPlaceSettings: boolean };

export type SaveAsKpiGeoSettingsMutationVariables = Types.Exact<{
  settings: Types.YalperAsKpiGeoSettingsInput;
}>;


export type SaveAsKpiGeoSettingsMutationPage = { readonly __typename?: 'RootMutationType', readonly saveAsKpiGeoSettings: boolean };

export type SaveStratLowConvSettingsMutationVariables = Types.Exact<{
  settings: Types.YalperStratLowConvSettingsInput;
}>;


export type SaveStratLowConvSettingsMutationPage = { readonly __typename?: 'RootMutationType', readonly saveStratLowConvSettings: boolean };

export type SaveAsMediaAdAnomalyGrowCpmSettingsMutationVariables = Types.Exact<{
  settings: Types.YalperAsMediaAdAnomalyGrowCpmSettingsInput;
}>;


export type SaveAsMediaAdAnomalyGrowCpmSettingsMutationPage = { readonly __typename?: 'RootMutationType', readonly saveAsMediaAdAnomalyGrowCpmSettings: boolean };

export type SaveAsCpmPlanExceededSettingsMutationVariables = Types.Exact<{
  settings: Types.YalperAsCpmPlanExceededSettingsInput;
}>;


export type SaveAsCpmPlanExceededSettingsMutationPage = { readonly __typename?: 'RootMutationType', readonly saveAsCpmPlanExceededSettings: boolean };

export type SaveAsCampaignAnomalyFallVtrSettingsMutationVariables = Types.Exact<{
  settings: Types.YalperAsCampaignAnomalyFallVtrSettingsInput;
}>;


export type SaveAsCampaignAnomalyFallVtrSettingsMutationPage = { readonly __typename?: 'RootMutationType', readonly saveAsCampaignAnomalyFallVtrSettings: boolean };

export type SaveAsAdAnomalyFallVisitDurationSettingsMutationVariables = Types.Exact<{
  settings: Types.YalperAsAdAnomalyFallVisitDurationSettingsInput;
}>;


export type SaveAsAdAnomalyFallVisitDurationSettingsMutationPage = { readonly __typename?: 'RootMutationType', readonly saveAsAdAnomalyFallVisitDurationSettings: boolean };

export type SaveAsAdAnomalyFallPageDepthSettingsMutationVariables = Types.Exact<{
  settings: Types.YalperAsAdAnomalyFallPageDepthSettingsInput;
}>;


export type SaveAsAdAnomalyFallPageDepthSettingsMutationPage = { readonly __typename?: 'RootMutationType', readonly saveAsAdAnomalyFallPageDepthSettings: boolean };


export const SaveGeoGroupsDocument = gql`
    mutation SaveGeoGroups($geoGroups: [YalperGeoGroupInput!]!) {
  saveGeoGroups(geoGroups: $geoGroups)
}
    `;
export type SaveGeoGroupsMutationFn = Apollo.MutationFunction<SaveGeoGroupsMutationPage, SaveGeoGroupsMutationVariables>;

/**
 * __useSaveGeoGroupsMutation__
 *
 * To run a mutation, you first call `useSaveGeoGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGeoGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGeoGroupsMutation, { data, loading, error }] = useSaveGeoGroupsMutation({
 *   variables: {
 *      geoGroups: // value for 'geoGroups'
 *   },
 * });
 */
export function useSaveGeoGroupsMutation(baseOptions?: Apollo.MutationHookOptions<SaveGeoGroupsMutationPage, SaveGeoGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveGeoGroupsMutationPage, SaveGeoGroupsMutationVariables>(SaveGeoGroupsDocument, options);
      }
export type SaveGeoGroupsMutationHookResult = ReturnType<typeof useSaveGeoGroupsMutation>;
export type SaveGeoGroupsMutationResult = Apollo.MutationResult<SaveGeoGroupsMutationPage>;
export type SaveGeoGroupsMutationOptions = Apollo.BaseMutationOptions<SaveGeoGroupsMutationPage, SaveGeoGroupsMutationVariables>;
export const CreateExceptionDocument = gql`
    mutation CreateException($companyId: ID!, $sensorName: String!, $platform: YalperPlatform!, $items: [YalperExceptionItemInput!]!) {
  createException(
    companyId: $companyId
    sensorName: $sensorName
    platform: $platform
    items: $items
  )
}
    `;
export type CreateExceptionMutationFn = Apollo.MutationFunction<CreateExceptionMutationPage, CreateExceptionMutationVariables>;

/**
 * __useCreateExceptionMutation__
 *
 * To run a mutation, you first call `useCreateExceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExceptionMutation, { data, loading, error }] = useCreateExceptionMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      sensorName: // value for 'sensorName'
 *      platform: // value for 'platform'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useCreateExceptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateExceptionMutationPage, CreateExceptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExceptionMutationPage, CreateExceptionMutationVariables>(CreateExceptionDocument, options);
      }
export type CreateExceptionMutationHookResult = ReturnType<typeof useCreateExceptionMutation>;
export type CreateExceptionMutationResult = Apollo.MutationResult<CreateExceptionMutationPage>;
export type CreateExceptionMutationOptions = Apollo.BaseMutationOptions<CreateExceptionMutationPage, CreateExceptionMutationVariables>;
export const DeleteExceptionDocument = gql`
    mutation DeleteException($id: ID!) {
  deleteException(id: $id)
}
    `;
export type DeleteExceptionMutationFn = Apollo.MutationFunction<DeleteExceptionMutationPage, DeleteExceptionMutationVariables>;

/**
 * __useDeleteExceptionMutation__
 *
 * To run a mutation, you first call `useDeleteExceptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExceptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExceptionMutation, { data, loading, error }] = useDeleteExceptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExceptionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExceptionMutationPage, DeleteExceptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExceptionMutationPage, DeleteExceptionMutationVariables>(DeleteExceptionDocument, options);
      }
export type DeleteExceptionMutationHookResult = ReturnType<typeof useDeleteExceptionMutation>;
export type DeleteExceptionMutationResult = Apollo.MutationResult<DeleteExceptionMutationPage>;
export type DeleteExceptionMutationOptions = Apollo.BaseMutationOptions<DeleteExceptionMutationPage, DeleteExceptionMutationVariables>;
export const SaveAdDoubleSettingsDocument = gql`
    mutation SaveAdDoubleSettings($settings: YalperAdDoubleSettingsInput!) {
  saveAdDoubleSettings(settings: $settings)
}
    `;
export type SaveAdDoubleSettingsMutationFn = Apollo.MutationFunction<SaveAdDoubleSettingsMutationPage, SaveAdDoubleSettingsMutationVariables>;

/**
 * __useSaveAdDoubleSettingsMutation__
 *
 * To run a mutation, you first call `useSaveAdDoubleSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAdDoubleSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAdDoubleSettingsMutation, { data, loading, error }] = useSaveAdDoubleSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveAdDoubleSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveAdDoubleSettingsMutationPage, SaveAdDoubleSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAdDoubleSettingsMutationPage, SaveAdDoubleSettingsMutationVariables>(SaveAdDoubleSettingsDocument, options);
      }
export type SaveAdDoubleSettingsMutationHookResult = ReturnType<typeof useSaveAdDoubleSettingsMutation>;
export type SaveAdDoubleSettingsMutationResult = Apollo.MutationResult<SaveAdDoubleSettingsMutationPage>;
export type SaveAdDoubleSettingsMutationOptions = Apollo.BaseMutationOptions<SaveAdDoubleSettingsMutationPage, SaveAdDoubleSettingsMutationVariables>;
export const SaveUtmCoherencySettingsDocument = gql`
    mutation SaveUtmCoherencySettings($settings: YalperUtmCoherencySettingsInput!) {
  saveUtmCoherencySettings(settings: $settings)
}
    `;
export type SaveUtmCoherencySettingsMutationFn = Apollo.MutationFunction<SaveUtmCoherencySettingsMutationPage, SaveUtmCoherencySettingsMutationVariables>;

/**
 * __useSaveUtmCoherencySettingsMutation__
 *
 * To run a mutation, you first call `useSaveUtmCoherencySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUtmCoherencySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUtmCoherencySettingsMutation, { data, loading, error }] = useSaveUtmCoherencySettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveUtmCoherencySettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveUtmCoherencySettingsMutationPage, SaveUtmCoherencySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUtmCoherencySettingsMutationPage, SaveUtmCoherencySettingsMutationVariables>(SaveUtmCoherencySettingsDocument, options);
      }
export type SaveUtmCoherencySettingsMutationHookResult = ReturnType<typeof useSaveUtmCoherencySettingsMutation>;
export type SaveUtmCoherencySettingsMutationResult = Apollo.MutationResult<SaveUtmCoherencySettingsMutationPage>;
export type SaveUtmCoherencySettingsMutationOptions = Apollo.BaseMutationOptions<SaveUtmCoherencySettingsMutationPage, SaveUtmCoherencySettingsMutationVariables>;
export const SaveUtmFormatMetrikaSettingsDocument = gql`
    mutation SaveUtmFormatMetrikaSettings($settings: YalperUtmFormatMetrikaSettingsInput!) {
  saveUtmFormatMetrikaSettings(settings: $settings)
}
    `;
export type SaveUtmFormatMetrikaSettingsMutationFn = Apollo.MutationFunction<SaveUtmFormatMetrikaSettingsMutationPage, SaveUtmFormatMetrikaSettingsMutationVariables>;

/**
 * __useSaveUtmFormatMetrikaSettingsMutation__
 *
 * To run a mutation, you first call `useSaveUtmFormatMetrikaSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUtmFormatMetrikaSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUtmFormatMetrikaSettingsMutation, { data, loading, error }] = useSaveUtmFormatMetrikaSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveUtmFormatMetrikaSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveUtmFormatMetrikaSettingsMutationPage, SaveUtmFormatMetrikaSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUtmFormatMetrikaSettingsMutationPage, SaveUtmFormatMetrikaSettingsMutationVariables>(SaveUtmFormatMetrikaSettingsDocument, options);
      }
export type SaveUtmFormatMetrikaSettingsMutationHookResult = ReturnType<typeof useSaveUtmFormatMetrikaSettingsMutation>;
export type SaveUtmFormatMetrikaSettingsMutationResult = Apollo.MutationResult<SaveUtmFormatMetrikaSettingsMutationPage>;
export type SaveUtmFormatMetrikaSettingsMutationOptions = Apollo.BaseMutationOptions<SaveUtmFormatMetrikaSettingsMutationPage, SaveUtmFormatMetrikaSettingsMutationVariables>;
export const SaveUtmFormatAppsflyerWebdavSettingsDocument = gql`
    mutation SaveUtmFormatAppsflyerWebdavSettings($settings: YalperUtmFormatAppsflyerWebdavSettingsInput!) {
  saveUtmFormatAppsflyerWebdavSettings(settings: $settings)
}
    `;
export type SaveUtmFormatAppsflyerWebdavSettingsMutationFn = Apollo.MutationFunction<SaveUtmFormatAppsflyerWebdavSettingsMutationPage, SaveUtmFormatAppsflyerWebdavSettingsMutationVariables>;

/**
 * __useSaveUtmFormatAppsflyerWebdavSettingsMutation__
 *
 * To run a mutation, you first call `useSaveUtmFormatAppsflyerWebdavSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUtmFormatAppsflyerWebdavSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUtmFormatAppsflyerWebdavSettingsMutation, { data, loading, error }] = useSaveUtmFormatAppsflyerWebdavSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveUtmFormatAppsflyerWebdavSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveUtmFormatAppsflyerWebdavSettingsMutationPage, SaveUtmFormatAppsflyerWebdavSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUtmFormatAppsflyerWebdavSettingsMutationPage, SaveUtmFormatAppsflyerWebdavSettingsMutationVariables>(SaveUtmFormatAppsflyerWebdavSettingsDocument, options);
      }
export type SaveUtmFormatAppsflyerWebdavSettingsMutationHookResult = ReturnType<typeof useSaveUtmFormatAppsflyerWebdavSettingsMutation>;
export type SaveUtmFormatAppsflyerWebdavSettingsMutationResult = Apollo.MutationResult<SaveUtmFormatAppsflyerWebdavSettingsMutationPage>;
export type SaveUtmFormatAppsflyerWebdavSettingsMutationOptions = Apollo.BaseMutationOptions<SaveUtmFormatAppsflyerWebdavSettingsMutationPage, SaveUtmFormatAppsflyerWebdavSettingsMutationVariables>;
export const SaveAsKpiAgeGenderSettingsDocument = gql`
    mutation SaveAsKpiAgeGenderSettings($settings: YalperAsKpiAgeGenderSettingsInput!) {
  saveAsKpiAgeGenderSettings(settings: $settings)
}
    `;
export type SaveAsKpiAgeGenderSettingsMutationFn = Apollo.MutationFunction<SaveAsKpiAgeGenderSettingsMutationPage, SaveAsKpiAgeGenderSettingsMutationVariables>;

/**
 * __useSaveAsKpiAgeGenderSettingsMutation__
 *
 * To run a mutation, you first call `useSaveAsKpiAgeGenderSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAsKpiAgeGenderSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAsKpiAgeGenderSettingsMutation, { data, loading, error }] = useSaveAsKpiAgeGenderSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveAsKpiAgeGenderSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveAsKpiAgeGenderSettingsMutationPage, SaveAsKpiAgeGenderSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAsKpiAgeGenderSettingsMutationPage, SaveAsKpiAgeGenderSettingsMutationVariables>(SaveAsKpiAgeGenderSettingsDocument, options);
      }
export type SaveAsKpiAgeGenderSettingsMutationHookResult = ReturnType<typeof useSaveAsKpiAgeGenderSettingsMutation>;
export type SaveAsKpiAgeGenderSettingsMutationResult = Apollo.MutationResult<SaveAsKpiAgeGenderSettingsMutationPage>;
export type SaveAsKpiAgeGenderSettingsMutationOptions = Apollo.BaseMutationOptions<SaveAsKpiAgeGenderSettingsMutationPage, SaveAsKpiAgeGenderSettingsMutationVariables>;
export const SaveAsKpiPlaceSettingsDocument = gql`
    mutation SaveAsKpiPlaceSettings($settings: YalperAsKpiPlaceSettingsInput!) {
  saveAsKpiPlaceSettings(settings: $settings)
}
    `;
export type SaveAsKpiPlaceSettingsMutationFn = Apollo.MutationFunction<SaveAsKpiPlaceSettingsMutationPage, SaveAsKpiPlaceSettingsMutationVariables>;

/**
 * __useSaveAsKpiPlaceSettingsMutation__
 *
 * To run a mutation, you first call `useSaveAsKpiPlaceSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAsKpiPlaceSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAsKpiPlaceSettingsMutation, { data, loading, error }] = useSaveAsKpiPlaceSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveAsKpiPlaceSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveAsKpiPlaceSettingsMutationPage, SaveAsKpiPlaceSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAsKpiPlaceSettingsMutationPage, SaveAsKpiPlaceSettingsMutationVariables>(SaveAsKpiPlaceSettingsDocument, options);
      }
export type SaveAsKpiPlaceSettingsMutationHookResult = ReturnType<typeof useSaveAsKpiPlaceSettingsMutation>;
export type SaveAsKpiPlaceSettingsMutationResult = Apollo.MutationResult<SaveAsKpiPlaceSettingsMutationPage>;
export type SaveAsKpiPlaceSettingsMutationOptions = Apollo.BaseMutationOptions<SaveAsKpiPlaceSettingsMutationPage, SaveAsKpiPlaceSettingsMutationVariables>;
export const SaveAsKpiGeoSettingsDocument = gql`
    mutation SaveAsKpiGeoSettings($settings: YalperAsKpiGeoSettingsInput!) {
  saveAsKpiGeoSettings(settings: $settings)
}
    `;
export type SaveAsKpiGeoSettingsMutationFn = Apollo.MutationFunction<SaveAsKpiGeoSettingsMutationPage, SaveAsKpiGeoSettingsMutationVariables>;

/**
 * __useSaveAsKpiGeoSettingsMutation__
 *
 * To run a mutation, you first call `useSaveAsKpiGeoSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAsKpiGeoSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAsKpiGeoSettingsMutation, { data, loading, error }] = useSaveAsKpiGeoSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveAsKpiGeoSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveAsKpiGeoSettingsMutationPage, SaveAsKpiGeoSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAsKpiGeoSettingsMutationPage, SaveAsKpiGeoSettingsMutationVariables>(SaveAsKpiGeoSettingsDocument, options);
      }
export type SaveAsKpiGeoSettingsMutationHookResult = ReturnType<typeof useSaveAsKpiGeoSettingsMutation>;
export type SaveAsKpiGeoSettingsMutationResult = Apollo.MutationResult<SaveAsKpiGeoSettingsMutationPage>;
export type SaveAsKpiGeoSettingsMutationOptions = Apollo.BaseMutationOptions<SaveAsKpiGeoSettingsMutationPage, SaveAsKpiGeoSettingsMutationVariables>;
export const SaveStratLowConvSettingsDocument = gql`
    mutation saveStratLowConvSettings($settings: YalperStratLowConvSettingsInput!) {
  saveStratLowConvSettings(settings: $settings)
}
    `;
export type SaveStratLowConvSettingsMutationFn = Apollo.MutationFunction<SaveStratLowConvSettingsMutationPage, SaveStratLowConvSettingsMutationVariables>;

/**
 * __useSaveStratLowConvSettingsMutation__
 *
 * To run a mutation, you first call `useSaveStratLowConvSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveStratLowConvSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveStratLowConvSettingsMutation, { data, loading, error }] = useSaveStratLowConvSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveStratLowConvSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveStratLowConvSettingsMutationPage, SaveStratLowConvSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveStratLowConvSettingsMutationPage, SaveStratLowConvSettingsMutationVariables>(SaveStratLowConvSettingsDocument, options);
      }
export type SaveStratLowConvSettingsMutationHookResult = ReturnType<typeof useSaveStratLowConvSettingsMutation>;
export type SaveStratLowConvSettingsMutationResult = Apollo.MutationResult<SaveStratLowConvSettingsMutationPage>;
export type SaveStratLowConvSettingsMutationOptions = Apollo.BaseMutationOptions<SaveStratLowConvSettingsMutationPage, SaveStratLowConvSettingsMutationVariables>;
export const SaveAsMediaAdAnomalyGrowCpmSettingsDocument = gql`
    mutation SaveAsMediaAdAnomalyGrowCpmSettings($settings: YalperAsMediaAdAnomalyGrowCpmSettingsInput!) {
  saveAsMediaAdAnomalyGrowCpmSettings(settings: $settings)
}
    `;
export type SaveAsMediaAdAnomalyGrowCpmSettingsMutationFn = Apollo.MutationFunction<SaveAsMediaAdAnomalyGrowCpmSettingsMutationPage, SaveAsMediaAdAnomalyGrowCpmSettingsMutationVariables>;

/**
 * __useSaveAsMediaAdAnomalyGrowCpmSettingsMutation__
 *
 * To run a mutation, you first call `useSaveAsMediaAdAnomalyGrowCpmSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAsMediaAdAnomalyGrowCpmSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAsMediaAdAnomalyGrowCpmSettingsMutation, { data, loading, error }] = useSaveAsMediaAdAnomalyGrowCpmSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveAsMediaAdAnomalyGrowCpmSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveAsMediaAdAnomalyGrowCpmSettingsMutationPage, SaveAsMediaAdAnomalyGrowCpmSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAsMediaAdAnomalyGrowCpmSettingsMutationPage, SaveAsMediaAdAnomalyGrowCpmSettingsMutationVariables>(SaveAsMediaAdAnomalyGrowCpmSettingsDocument, options);
      }
export type SaveAsMediaAdAnomalyGrowCpmSettingsMutationHookResult = ReturnType<typeof useSaveAsMediaAdAnomalyGrowCpmSettingsMutation>;
export type SaveAsMediaAdAnomalyGrowCpmSettingsMutationResult = Apollo.MutationResult<SaveAsMediaAdAnomalyGrowCpmSettingsMutationPage>;
export type SaveAsMediaAdAnomalyGrowCpmSettingsMutationOptions = Apollo.BaseMutationOptions<SaveAsMediaAdAnomalyGrowCpmSettingsMutationPage, SaveAsMediaAdAnomalyGrowCpmSettingsMutationVariables>;
export const SaveAsCpmPlanExceededSettingsDocument = gql`
    mutation SaveAsCpmPlanExceededSettings($settings: YalperAsCpmPlanExceededSettingsInput!) {
  saveAsCpmPlanExceededSettings(settings: $settings)
}
    `;
export type SaveAsCpmPlanExceededSettingsMutationFn = Apollo.MutationFunction<SaveAsCpmPlanExceededSettingsMutationPage, SaveAsCpmPlanExceededSettingsMutationVariables>;

/**
 * __useSaveAsCpmPlanExceededSettingsMutation__
 *
 * To run a mutation, you first call `useSaveAsCpmPlanExceededSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAsCpmPlanExceededSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAsCpmPlanExceededSettingsMutation, { data, loading, error }] = useSaveAsCpmPlanExceededSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveAsCpmPlanExceededSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveAsCpmPlanExceededSettingsMutationPage, SaveAsCpmPlanExceededSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAsCpmPlanExceededSettingsMutationPage, SaveAsCpmPlanExceededSettingsMutationVariables>(SaveAsCpmPlanExceededSettingsDocument, options);
      }
export type SaveAsCpmPlanExceededSettingsMutationHookResult = ReturnType<typeof useSaveAsCpmPlanExceededSettingsMutation>;
export type SaveAsCpmPlanExceededSettingsMutationResult = Apollo.MutationResult<SaveAsCpmPlanExceededSettingsMutationPage>;
export type SaveAsCpmPlanExceededSettingsMutationOptions = Apollo.BaseMutationOptions<SaveAsCpmPlanExceededSettingsMutationPage, SaveAsCpmPlanExceededSettingsMutationVariables>;
export const SaveAsCampaignAnomalyFallVtrSettingsDocument = gql`
    mutation SaveAsCampaignAnomalyFallVtrSettings($settings: YalperAsCampaignAnomalyFallVtrSettingsInput!) {
  saveAsCampaignAnomalyFallVtrSettings(settings: $settings)
}
    `;
export type SaveAsCampaignAnomalyFallVtrSettingsMutationFn = Apollo.MutationFunction<SaveAsCampaignAnomalyFallVtrSettingsMutationPage, SaveAsCampaignAnomalyFallVtrSettingsMutationVariables>;

/**
 * __useSaveAsCampaignAnomalyFallVtrSettingsMutation__
 *
 * To run a mutation, you first call `useSaveAsCampaignAnomalyFallVtrSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAsCampaignAnomalyFallVtrSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAsCampaignAnomalyFallVtrSettingsMutation, { data, loading, error }] = useSaveAsCampaignAnomalyFallVtrSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveAsCampaignAnomalyFallVtrSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveAsCampaignAnomalyFallVtrSettingsMutationPage, SaveAsCampaignAnomalyFallVtrSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAsCampaignAnomalyFallVtrSettingsMutationPage, SaveAsCampaignAnomalyFallVtrSettingsMutationVariables>(SaveAsCampaignAnomalyFallVtrSettingsDocument, options);
      }
export type SaveAsCampaignAnomalyFallVtrSettingsMutationHookResult = ReturnType<typeof useSaveAsCampaignAnomalyFallVtrSettingsMutation>;
export type SaveAsCampaignAnomalyFallVtrSettingsMutationResult = Apollo.MutationResult<SaveAsCampaignAnomalyFallVtrSettingsMutationPage>;
export type SaveAsCampaignAnomalyFallVtrSettingsMutationOptions = Apollo.BaseMutationOptions<SaveAsCampaignAnomalyFallVtrSettingsMutationPage, SaveAsCampaignAnomalyFallVtrSettingsMutationVariables>;
export const SaveAsAdAnomalyFallVisitDurationSettingsDocument = gql`
    mutation SaveAsAdAnomalyFallVisitDurationSettings($settings: YalperAsAdAnomalyFallVisitDurationSettingsInput!) {
  saveAsAdAnomalyFallVisitDurationSettings(settings: $settings)
}
    `;
export type SaveAsAdAnomalyFallVisitDurationSettingsMutationFn = Apollo.MutationFunction<SaveAsAdAnomalyFallVisitDurationSettingsMutationPage, SaveAsAdAnomalyFallVisitDurationSettingsMutationVariables>;

/**
 * __useSaveAsAdAnomalyFallVisitDurationSettingsMutation__
 *
 * To run a mutation, you first call `useSaveAsAdAnomalyFallVisitDurationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAsAdAnomalyFallVisitDurationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAsAdAnomalyFallVisitDurationSettingsMutation, { data, loading, error }] = useSaveAsAdAnomalyFallVisitDurationSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveAsAdAnomalyFallVisitDurationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveAsAdAnomalyFallVisitDurationSettingsMutationPage, SaveAsAdAnomalyFallVisitDurationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAsAdAnomalyFallVisitDurationSettingsMutationPage, SaveAsAdAnomalyFallVisitDurationSettingsMutationVariables>(SaveAsAdAnomalyFallVisitDurationSettingsDocument, options);
      }
export type SaveAsAdAnomalyFallVisitDurationSettingsMutationHookResult = ReturnType<typeof useSaveAsAdAnomalyFallVisitDurationSettingsMutation>;
export type SaveAsAdAnomalyFallVisitDurationSettingsMutationResult = Apollo.MutationResult<SaveAsAdAnomalyFallVisitDurationSettingsMutationPage>;
export type SaveAsAdAnomalyFallVisitDurationSettingsMutationOptions = Apollo.BaseMutationOptions<SaveAsAdAnomalyFallVisitDurationSettingsMutationPage, SaveAsAdAnomalyFallVisitDurationSettingsMutationVariables>;
export const SaveAsAdAnomalyFallPageDepthSettingsDocument = gql`
    mutation SaveAsAdAnomalyFallPageDepthSettings($settings: YalperAsAdAnomalyFallPageDepthSettingsInput!) {
  saveAsAdAnomalyFallPageDepthSettings(settings: $settings)
}
    `;
export type SaveAsAdAnomalyFallPageDepthSettingsMutationFn = Apollo.MutationFunction<SaveAsAdAnomalyFallPageDepthSettingsMutationPage, SaveAsAdAnomalyFallPageDepthSettingsMutationVariables>;

/**
 * __useSaveAsAdAnomalyFallPageDepthSettingsMutation__
 *
 * To run a mutation, you first call `useSaveAsAdAnomalyFallPageDepthSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAsAdAnomalyFallPageDepthSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAsAdAnomalyFallPageDepthSettingsMutation, { data, loading, error }] = useSaveAsAdAnomalyFallPageDepthSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveAsAdAnomalyFallPageDepthSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveAsAdAnomalyFallPageDepthSettingsMutationPage, SaveAsAdAnomalyFallPageDepthSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAsAdAnomalyFallPageDepthSettingsMutationPage, SaveAsAdAnomalyFallPageDepthSettingsMutationVariables>(SaveAsAdAnomalyFallPageDepthSettingsDocument, options);
      }
export type SaveAsAdAnomalyFallPageDepthSettingsMutationHookResult = ReturnType<typeof useSaveAsAdAnomalyFallPageDepthSettingsMutation>;
export type SaveAsAdAnomalyFallPageDepthSettingsMutationResult = Apollo.MutationResult<SaveAsAdAnomalyFallPageDepthSettingsMutationPage>;
export type SaveAsAdAnomalyFallPageDepthSettingsMutationOptions = Apollo.BaseMutationOptions<SaveAsAdAnomalyFallPageDepthSettingsMutationPage, SaveAsAdAnomalyFallPageDepthSettingsMutationVariables>;